export default __webpack_public_path__ + "static/media/EditPencil.6a492ab4.svg";